<!-- Community List-->
<div class="card-columns">
  <community-preview
    *ngFor="let community of results"
    [community]="community"
    [query]="query"
    (setTagTo)="setTagTo($event)"
  ></community-preview>
</div>

<!-- Loader spinner -->
<loader-animation [loading]="loading" [message]="'Loading uMuzis'">
</loader-animation>
<!-- Loader spinner -->

<!-- No content message-->
<no-content-msg
  [hidden]="loading || results.length"
  [message]="'No uMuzis here yet'"
>
</no-content-msg>
<!-- No content message -->

<!-- Pagination -->
<pagination-buttons
  [currentPage]="currentPage"
  [loading]="loading"
  [showNavBar]="true"
  [smallButtons]="false"
  [totalPageCount]="totalPages"
  (setPageTo)="setPageTo($event)"
>
</pagination-buttons>
<!-- Pagination -->
